import { ToggleButton as TB, ToggleButtonGroup as TBG, ToggleButtonGroupProps as TBGProps, ToggleButtonProps as TBProps } from '@mui/material';

export const MuiToggleButton = (props: TBProps) => {
	return <TB {...props} />;
};

export const MuiToggleButtonGroup = (props: TBGProps) => {
	return <TBG {...props} />;
};

export type MuiToggleButtonProps = TBProps;
export type MuiToggleButtonGroupProps = TBGProps;

export function ModeSwitch<T extends string>(props: {
	opts: Record<T, string>;
	value?: T;
	setValue: (a: T) => void;
	/** When enabled, prevents the value from being cleared when the user clicks the currently selected option without choosing another. */
	disableClearable?: boolean;

	color?: TBGProps['color'];
	fullWidth?: boolean;
}) {
	return (
		<MuiToggleButtonGroup
			value={props.value}
			onChange={(e, v) => {
				if (v === null && props.disableClearable) return;
				props.setValue(v);
			}}
			exclusive
			fullWidth={props.fullWidth}
			color={props?.color ?? 'primary'}
		>
			{Object.entries(props.opts).map(([k, v]) => (
				<MuiToggleButton key={`toggle-${k}`} size={'small'} sx={{ borderRadius: 2, textTransform: 'none' }} value={k}>
					{v as string}
				</MuiToggleButton>
			))}
		</MuiToggleButtonGroup>
	);
}
